package ru.playa.sce.core

fun main(args: Array<String>) {
    Application.run()
}
